"use client"
import { Container, Typography, Box, Paper, useTheme } from "@mui/material"
import SecurityIcon from "@mui/icons-material/Security"

const PrivacyPolicy = () => {
  const theme = useTheme()

  return (
    <Container maxWidth="md">
      <Paper
        elevation={3}
        sx={{
          p: 4,
          background: "rgba(13, 15, 25, 0.7)",
          border: "1px solid rgba(0, 229, 255, 0.1)",
          borderRadius: 2,
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 4, gap: 2 }}>
          <SecurityIcon
            sx={{
              fontSize: 40,
              color: theme.palette.primary.main,
              textShadow: "0 0 8px rgba(0, 229, 255, 0.6)",
            }}
          />
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: "bold",
              background: "linear-gradient(45deg, #ffffff 30%, #00e5ff 90%)",
              backgroundClip: "text",
              textFillColor: "transparent",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              textShadow: "0 0 2px rgba(0, 229, 255, 0.5)",
            }}
          >
            Privacy Policy
          </Typography>
        </Box>

        <Typography variant="body1" paragraph>
          Last updated: {new Date().toLocaleDateString()}
        </Typography>

        <Typography variant="h6" sx={{ color: theme.palette.primary.main, mt: 4, mb: 2 }}>
          1. Introduction
        </Typography>
        <Typography variant="body1" paragraph>
          Welcome to DarkEdge. We respect your privacy and are committed to protecting your personal data. This privacy
          policy will inform you about how we look after your personal data when you visit our website and tell you
          about your privacy rights and how the law protects you.
        </Typography>

        <Typography variant="h6" sx={{ color: theme.palette.primary.main, mt: 4, mb: 2 }}>
          2. Data We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          When you use our service, we may collect the following types of information:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
          <li>Discord account information (username, ID, avatar)</li>
          <li>Discord server roles and permissions</li>
          <li>Connection status and usage statistics</li>
          <li>Payment information (processed by third-party payment processors)</li>
        </Typography>

        <Typography variant="h6" sx={{ color: theme.palette.primary.main, mt: 4, mb: 2 }}>
          3. How We Use Your Data
        </Typography>
        <Typography variant="body1" paragraph>
          We use your personal data for the following purposes:
        </Typography>
        <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
          <li>To provide and maintain our service</li>
          <li>To notify you about changes to our service</li>
          <li>To allow you to participate in interactive features of our service</li>
          <li>To provide customer support</li>
          <li>To gather analysis or valuable information so that we can improve our service</li>
          <li>To monitor the usage of our service</li>
          <li>To detect, prevent and address technical issues</li>
        </Typography>

        <Typography variant="h6" sx={{ color: theme.palette.primary.main, mt: 4, mb: 2 }}>
          4. Data Security
        </Typography>
        <Typography variant="body1" paragraph>
          We have implemented appropriate security measures to prevent your personal data from being accidentally lost,
          used, or accessed in an unauthorized way, altered, or disclosed. In addition, we limit access to your personal
          data to those employees, agents, contractors, and other third parties who have a business need to know.
        </Typography>

        <Typography variant="h6" sx={{ color: theme.palette.primary.main, mt: 4, mb: 2 }}>
          5. Your Rights
        </Typography>
        <Typography variant="body1" paragraph>
          Under certain circumstances, you have rights under data protection laws in relation to your personal data,
          including the right to request access, correction, erasure, restriction, transfer, to object to processing, to
          portability of data, and (where the lawful ground of processing is consent) to withdraw consent.
        </Typography>

        <Typography variant="h6" sx={{ color: theme.palette.primary.main, mt: 4, mb: 2 }}>
          6. Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy, please contact us through our Discord server or via the
          Contact page.
        </Typography>
      </Paper>
    </Container>
  )
}

export default PrivacyPolicy
